import { createStore, createTypedHooks, action, Action } from 'easy-peasy'

import search, { SearchModel } from './models/search'
import tracking, { TrackingModel } from './models/tracking'

export interface StoreModel {
  search: SearchModel
  tracking: TrackingModel
  reset: Action<StoreModel, any>
}

const model: StoreModel = {
  search,
  tracking,

  /** This is a test helper to ensure that tests are run with a clean store each time */
  reset: action((state, payload) => payload)
}

const store = createStore(model, {
  name: 'real-estate-agents-table-store'
})

export default store

export const { useStoreState, useStoreActions, useStoreDispatch } =
  createTypedHooks<StoreModel>()
